document.querySelectorAll('[data-certnz-site-header]').forEach((header) => {
  const button = header.querySelector('[data-certnz-menu-toggle]');
  const panel = header.querySelector('[data-certnz-mobile-nav]');

  if (!button || !panel) return;

  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  });

  panel.addEventListener('click', (event) => {
    if (!event.target.closest('a')) return;
    button.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  });
});
